import { PropsWithChildren } from "react";
import cx from "classnames";
import Info from "../../assets/Info.svg";

export const StatusBanner: React.FC<
  PropsWithChildren<{
    variant?: "error" | "card";
    title: string;
    show?: boolean;
    containerClassName?: string;
  }>
> = ({
  variant = "error",
  title,
  children,
  show = true,
  containerClassName
}) => {
  if (!show) return null;
  const className =
    "bg-coinage-offWhite border-coinage-blue rounded-md border-[1px] flex flex-row p-4 gap-4 items-start text-left";
  const bannerStyles = cx(className, {
    "bg-card": variant === "card"
  });
  return (
    <section className={cx("max-w-5xl min-w-[380px] px-4", containerClassName)}>
      <div className={bannerStyles}>
        <Info width="24" className="text-coinage-burgundy mt-1" />
        <div className="max-w-2xl">
          <h4 className="subhead2 text-coinage-blue mb-1">{title}</h4>
          {children && <p className="body2 text-coinage-body">{children}</p>}
        </div>
      </div>
    </section>
  );
};
